/* eslint-disable react/function-component-definition */
import { Backdrop, Box, CircularProgress } from "@mui/material";
import React from "react";

interface LoaderProps
{
	isMinHeight?: boolean;
	minHeight?: string;
	size?: number;
	color?: "primary" | "secondary" | "error" | "info" | "success" | "warning" | "inherit";
}

interface LoaderBackdropProps
{
	isLoading: boolean;
	children?: React.ReactNode | undefined;
}

// eslint-disable-next-line func-style
const Loader: React.FC<LoaderProps> = ({ isMinHeight = false, minHeight = "", color = "info", size }) =>
{
	return (
		<Box display="flex" justifyContent="center" alignItems="center" minHeight={isMinHeight ? "100vh" : minHeight}>
			<CircularProgress color={color} size={size} />
		</Box>
	);
};

// eslint-disable-next-line func-style
export const LoaderBackdrop: React.FC<LoaderBackdropProps> = ({ isLoading, children }) =>
{
	return (
		<Box
			position="relative"
			sx={{
				opacity: isLoading ? 0.4 : 1
			}}
		>
			{children}

			<Backdrop open={isLoading} sx={{ background: "none", position: "absolute" }}>
				<Loader />
			</Backdrop>
		</Box>
	);
};

export default Loader;
